import React from 'react';
import Utils from '../../../../utils/utils';
import translate from '../../../../utils/translate';
import OmnitureHelper from '../../../../utils/omniture-helper';
import Cookies from 'js-cookie';

export default class HeaderSearchResultsItem extends React.Component {
  static propTypes = {
    searchTerm: React.PropTypes.string,
    title:      React.PropTypes.string,
    city:       React.PropTypes.string,
    count:      React.PropTypes.number,
    link:       React.PropTypes.string
  };

  /**
   * Function splits search term and suggestion. Then loop through
   * search terms and calls recursive function to loop through suggestions.
   *
   * @param  {String} suggestion        Actual suggestion
   * @return {String}                   Actual suggestion with highlighting
   */
  highlightSearchTerm = (suggestion) => {
    let terms = this.props.searchTerm.trim().split(' ');
    const suggestions = suggestion.split(' ');
    const suggestionsLength = suggestions.length - 1;
    const len = terms.length;
    let i;

    // Sort array of terms from longest to shortest
    terms = this.sortArray(terms);

    // Loop through search terms
    for (i = 0; i < len; i += 1) {
      // Call recursive function to walk through suggestions array
      this.walkThroughArray(terms[i], suggestions, suggestionsLength);
    }

    return suggestions.join(' ');
  };

  /**
   * Sort array from longest word to shortest
   * @param  {Array} terms Array of terms
   * @return {Array}       New sorted array
   */
  sortArray = (terms) => {
    return terms.sort((a, b) => b.length - a.length);
  };

  /**
   * Find match and format suggestion. The search term is escaped before being used in a second regular expression
   * so that special characters don't break the query.
   *
   * @param  {String} term       Actual search term
   * @param  {String} suggestion Actual suggestion
   * @return {String}            Original or changed suggestion
   */
  getNewSuggestion = (term, suggestion) => {
    const regexTerm = term.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
    const rgxp = new RegExp('^(' + regexTerm + ')(?![^<>]*?(</em>|>))', 'i');
    const newSuggestion = this.formatString(suggestion);
    let termStartPosition, termEndPosition;

    // Find match and remember string start position and length
    termStartPosition = newSuggestion.search(rgxp);

    // There is a match so calculate last char position
    termEndPosition = termStartPosition + term.length;

    // Is there a match? If there is no match str.search will return -1
    if (termStartPosition === -1) {
      return suggestion;
    }

    const firstChars = suggestion.substring(0, termStartPosition);
    const middleChars = suggestion.substring(termStartPosition, termEndPosition);
    const lastChars = suggestion.substring(termEndPosition);

    return firstChars + '<em>' + middleChars + '</em>' + lastChars;
  };

  /**
   * Prepare string for matching
   *
   * To Lower Case
   * Remove special characters
   *
   * @return {String} Formatted string
   */
  formatString = (term) => {
    // Remove all special characters
    return Utils.removeSpecialChars(term.toLowerCase());
  };

  /**
   * Recursive function walks through whole array of suggestions
   * and adds <em> if match has been found
   *
   * @param {String} term        Actual search term we are matching
   * @param {Array}  suggestions Suggestions array
   * @param {Number} iteration   Actual itration number
   */
  walkThroughArray = (term, suggestions, iteration) => {
    // First we need to format string to default state
    const termString = this.formatString(term);
    const primarySuggestion = suggestions[iteration];

    suggestions[iteration] = this.getNewSuggestion(termString, primarySuggestion);

    // We are not done. Do another iteration.
    if (iteration-- > 0) {
      this.walkThroughArray(term, suggestions, iteration);
    }
  };

  sendToOmniture = () => {
    // Set cookie. Will be picked up by controller
    Cookies.set('suggestion', this.props.searchTerm, { expires: 60 * 60 * 24 });

    const omnitureString = this.props.searchTerm + ' > ' + this.props.title;

    const omnitureData = {
      'prop5': omnitureString,
      'eVar7': omnitureString
    };

    if (OmnitureHelper && omnitureData) {
      OmnitureHelper.send(omnitureData);
    }
  };

  render () {
    const cityName = (this.props.city !== null ? ', ' + this.props.city : '');
    const eventsTU = (this.props.count === 1
      ? translate('searchSuggestModule', 'EVENT')
      : translate('searchSuggestModule', 'EVENTS'));
    const eventCount = (this.props.count !== 0 ? '(' + this.props.count + ' ' + eventsTU + ')' : '');

    return (
      <li
        className="header__searchresults__group__item"
        data-component="header-searchresults-item"
        data-search-term={this.props.title + cityName}>
        <a className="header__searchresults__group__link" href={this.props.link} onClick={this.sendToOmniture}>
          <span
            className="header__searchresults__group__result"
            dangerouslySetInnerHTML={{__html: this.highlightSearchTerm(this.props.title + cityName)}}
          />
          <span className="header__searchresults__group__count">{eventCount}</span>
        </a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/searchresults/resultItem/index.js